function portfolioPageLoaded() {
	jQuery(window).load(function() {
		loading_screen.finish();

		jQuery('.scroll-down').delay(2000).fadeTo('600', 1).addClass('animate');
	});
}